import React from 'react';
import PropTypes from 'prop-types';

function ChatInput({ value, onChange, ...props }) {
  return (
    <input
      type="text"
      value={value}
      className="input-chat"
      onChange={onChange}
      placeholder="Type something here..."
      {...props}
    />
  );
}

ChatInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChatInput;
